/* eslint-disable @typescript-eslint/lines-between-class-members */
import { ApprovedTypesEnum } from 'APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';

import { KnmStatusesEnum } from '../enums/KnmStatusesEnum';
import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { IErknmInfoExcludeDatesResponse } from '../../../KnmErknmPackage/ErknmInfoModule/interfaces/IErknmInfoExcludeDatesResponse';
import { IKnmPunishmentNature } from '../../../APIPackage/KnmModule/interfaces/IKnmPunishmentNature';
import { IKnmErknmForm } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmForm';
import { ICatalogsState } from '../../../CorePackage/CatalogsModule/interfaces/ICatalogsState';
import { ComplexCatalogsNamesEnum } from '../../../CorePackage/CatalogsModule/enums/ComplexCatalogsNamesEnum';

export class KnmFormValidator {
  isErknm?: boolean = undefined;
  isPm?: boolean = undefined;
  isSupervisor?: boolean = undefined; // 1
  isProsecutor?: boolean = undefined;
  isWatchOnly?: boolean = undefined;
  planFindStatus?: KnmStatusesEnum = undefined;
  isNewKnm?: boolean = undefined;
  isCopyEnabled?: boolean = undefined;
  isKnmStatusFillInProcess?: boolean = undefined;
  isKnmStatusReadyForApprove?: boolean = undefined;
  isKnmStatusApproving?: boolean = undefined;
  isKnmStatusTypeWaitingCarryOut?: boolean = undefined;
  isKnmStatusTypeCarriedOut?: boolean = undefined;
  isKnmStatusTypeCompleted?: boolean = undefined;
  isKnmStatusTypeDecisionAppealed?: boolean = undefined;
  isKnmStatusTypeCantBeCarryOut?: boolean = undefined;
  isKnmStatusCommentsExist?: boolean = undefined;
  isErknmStatusAgreementOnApproval?: boolean = undefined;
  knmPlanStatus?: ErknmPlanStatusesEnum = undefined;
  knmDataApprovedType?: ApprovedTypesEnum | null = undefined;
  knmDataNote?: string | null = undefined;
  knmData?: IKnm = undefined;
  settings?: IAdminSetting[] = undefined; // 1
  isEditableInStatusCommentsExist?: boolean = undefined;
  isErknmStatusRejected?: boolean = undefined;
  knoSupervisionStartDate?: string = undefined;
  isStartDateIsCurrentYear?: boolean = undefined; // 1
  excludeDates?: IErknmInfoExcludeDatesResponse = undefined; // 1
  punishmentNature?: IKnmPunishmentNature[] = undefined;
  knoSupervisionParentUuid?: string = undefined;
  initialErknmValues?: IKnmErknmForm = undefined; // 1
  fnsRegistryOkvedCodes?: ICatalogsState[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES] = undefined;
  // Признаки повторной проверки, те же, по которым интерфейс решает, показывать ли
  // блок повторного нарушения
  isPassportByCheckPrescriptionOldRules?: boolean = undefined;
  isPassportByCheckPrescriptionFailed?: boolean = undefined;
}
